import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { SharedModule } from '@shared/shared.module';
import { HD_LANG_RECOMPUTE_ON_LOAD, HdContentLanguageService } from '@/app/human-design/chart/bodygraph/hd-content-language.service';
import { HdEphemerisTableComponent } from '@/app/human-design/ephemeris/hd-ephemeris-table/hd-ephemeris-table.component';

/**
 * Ephemeris-pagina (spec `docs/superpowers/specs/2026-10-13-ephemeris-pagina-design.md`):
 * dunne route `/human-design/ephemeris` rond de ephemeris-tabel. Werkt zonder geladen chart.
 */
@Component({
  selector: 'hd-ephemeris-page',
  standalone: true,
  imports: [SharedModule, HdEphemerisTableComponent],
  templateUrl: './hd-ephemeris-page.component.html',
  styleUrl: './hd-ephemeris-page.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HdEphemerisPageComponent {
  private readonly transloco = inject(TranslocoService);
  private readonly contentLang = inject(HdContentLanguageService);

  private readonly lang = computed(() => {
    this.contentLang.translationsLoadedTick();
    return this.contentLang.effectiveLang();
  }, HD_LANG_RECOMPUTE_ON_LOAD);

  protected readonly title = computed(() =>
    this.transloco.translate<string>('humanDesign.ephemeris.title', undefined, this.lang()),
  );
}
